import React from 'react';
import { FaPhoneAlt, FaWhatsapp, FaShieldAlt, FaClock, FaMapMarkerAlt, FaStar, FaTools } from 'react-icons/fa';
import SITE from '../../Data/siteConfig';
import heroImage from '../../images/hero-illustration.png';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" aria-label="Üç Kardeşler Teknik Servis tanıtım">
      <div className="hero-bg-decor" aria-hidden="true" />

      <div className="hero-inner">
        {/* Sol: metin + CTA */}
        <div className="hero-content">
          <div className="hero-badges">
            <span className="badge badge-light"><FaClock /> 7/24 Hizmet</span>
            <span className="badge badge-light"><FaMapMarkerAlt /> Bursa</span>
            <span className="badge badge-light"><FaShieldAlt /> Garantili İşçilik</span>
          </div>

          <h1 className="hero-title">
            Bursa Kombi, Klima ve Beyaz Eşya <span className="hero-title-accent">Teknik Servisi</span>
          </h1>

          <p className="hero-subtitle">
            Osmangazi merkezli uzman ekibimizle kombi bakımı, petek temizliği, klima servisi
            ve beyaz eşya tamirinde <strong>aynı gün</strong> çözüm sunuyoruz.
          </p>

          <div className="hero-cta btn-group">
            <a href={SITE.phoneHref} className="btn btn-call">
              <FaPhoneAlt className="btn-icon" /> Hemen Ara
            </a>
            <a
              href={SITE.whatsapp}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-whatsapp"
            >
              <FaWhatsapp className="btn-icon" /> WhatsApp'tan Yaz
            </a>
          </div>

          {/* Inline güven istatistikleri */}
          <div className="hero-stats">
            <div className="hero-stat">
              <span className="hero-stat-value">8+</span>
              <span className="hero-stat-label">Yıl Tecrübe</span>
            </div>
            <div className="hero-stat-divider" />
            <div className="hero-stat">
              <span className="hero-stat-value">1500+</span>
              <span className="hero-stat-label">Servis</span>
            </div>
            <div className="hero-stat-divider" />
            <div className="hero-stat">
              <span className="hero-stat-value">~15 dk</span>
              <span className="hero-stat-label">Yanıt Süresi</span>
            </div>
          </div>
        </div>

        {/* Sağ: görsel kartı + yüzen mini kartlar */}
        <div className="hero-visual">
          <div className="hero-image-card">
            <img
              className="hero-image"
              src={heroImage}
              alt="Bursa kombi, klima, çamaşır makinesi ve buzdolabı teknik servisi - üniformalı teknisyen"
              loading="eager"
              decoding="async"
            />
          </div>

          <div className="hero-float hero-float-rating">
            <FaStar className="hero-float-icon star" />
            <div>
              <strong>4.9/5</strong>
              <small>Müşteri memnuniyeti</small>
            </div>
          </div>

          <div className="hero-float hero-float-service">
            <span className="hero-float-pulse"><FaTools /></span>
            <div>
              <strong>7/24 Açık</strong>
              <small>Aynı gün servis</small>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
